"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOidcIdToken = exports.useOidcAccessToken = exports.useOidc = void 0;
const react_1 = require("react");
const vanillaOidc_js_1 = require("./vanilla/vanillaOidc.js");
const defaultConfigurationName = 'default';
const defaultIsAuthenticated = (getOidc, configurationName) => {
    let isAuthenticated = false;
    const oidc = getOidc(configurationName);
    if (oidc) {
        isAuthenticated = getOidc(configurationName).tokens != null;
    }
    return isAuthenticated;
};
const useOidc = (configurationName = defaultConfigurationName) => {
    const getOidc = vanillaOidc_js_1.VanillaOidc.get;
    const [isAuthenticated, setIsAuthenticated] = (0, react_1.useState)(defaultIsAuthenticated(getOidc, configurationName));
    (0, react_1.useEffect)(() => {
        let isMounted = true;
        const oidc = getOidc(configurationName);
        setIsAuthenticated(defaultIsAuthenticated(getOidc, configurationName));
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const newSubscriptionId = oidc.subscribeEvents((name, data) => {
            if (name === vanillaOidc_js_1.VanillaOidc.eventNames.logout_from_another_tab || name === vanillaOidc_js_1.VanillaOidc.eventNames.logout_from_same_tab || name === vanillaOidc_js_1.VanillaOidc.eventNames.token_aquired) {
                if (isMounted) {
                    setIsAuthenticated(defaultIsAuthenticated(getOidc, configurationName));
                }
            }
        });
        return () => {
            isMounted = false;
            oidc.removeEventSubscription(newSubscriptionId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configurationName]);
    const login = (callbackPath = undefined, extras = null, silentLoginOnly = false) => {
        return getOidc(configurationName).loginAsync(callbackPath, extras, false, undefined, silentLoginOnly);
    };
    const logout = (callbackPath = undefined, extras = null) => {
        return getOidc(configurationName).logoutAsync(callbackPath, extras);
    };
    const renewTokens = (extras = null) => __awaiter(void 0, void 0, void 0, function* () {
        const tokens = yield getOidc(configurationName).renewTokensAsync(extras);
        return {
            // @ts-ignore
            accessToken: tokens.accessToken,
            // @ts-ignore
            accessTokenPayload: tokens.accessTokenPayload,
            // @ts-ignore
            idToken: tokens.idToken,
            // @ts-ignore
            idTokenPayload: tokens.idTokenPayload,
        };
    });
    return { login, logout, renewTokens, isAuthenticated };
};
exports.useOidc = useOidc;
const accessTokenInitialState = { accessToken: null, accessTokenPayload: null };
const initTokens = (configurationName) => {
    const getOidc = vanillaOidc_js_1.VanillaOidc.get;
    const oidc = getOidc(configurationName);
    if (oidc.tokens) {
        const tokens = oidc.tokens;
        return {
            accessToken: tokens.accessToken,
            accessTokenPayload: tokens.accessTokenPayload,
        };
    }
    return accessTokenInitialState;
};
const useOidcAccessToken = (configurationName = defaultConfigurationName) => {
    const getOidc = vanillaOidc_js_1.VanillaOidc.get;
    const [state, setAccessToken] = (0, react_1.useState)(initTokens(configurationName));
    (0, react_1.useEffect)(() => {
        let isMounted = true;
        const oidc = getOidc(configurationName);
        if (oidc.tokens) {
            const tokens = oidc.tokens;
            setAccessToken({ accessToken: tokens.accessToken, accessTokenPayload: tokens.accessTokenPayload });
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const newSubscriptionId = oidc.subscribeEvents((name, data) => {
            if (name === vanillaOidc_js_1.VanillaOidc.eventNames.token_renewed ||
                name === vanillaOidc_js_1.VanillaOidc.eventNames.token_aquired ||
                name === vanillaOidc_js_1.VanillaOidc.eventNames.logout_from_another_tab ||
                name === vanillaOidc_js_1.VanillaOidc.eventNames.logout_from_same_tab ||
                name === vanillaOidc_js_1.VanillaOidc.eventNames.refreshTokensAsync_error ||
                name === vanillaOidc_js_1.VanillaOidc.eventNames.syncTokensAsync_error) {
                if (isMounted) {
                    const tokens = oidc.tokens;
                    setAccessToken(tokens != null ? { accessToken: tokens.accessToken, accessTokenPayload: tokens.accessTokenPayload } : accessTokenInitialState);
                }
            }
        });
        return () => {
            isMounted = false;
            oidc.removeEventSubscription(newSubscriptionId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configurationName]);
    return state;
};
exports.useOidcAccessToken = useOidcAccessToken;
const idTokenInitialState = { idToken: null, idTokenPayload: null };
const initIdToken = (configurationName) => {
    const getOidc = vanillaOidc_js_1.VanillaOidc.get;
    const oidc = getOidc(configurationName);
    if (oidc.tokens) {
        const tokens = oidc.tokens;
        return { idToken: tokens.idToken, idTokenPayload: tokens.idTokenPayload };
    }
    return idTokenInitialState;
};
const useOidcIdToken = (configurationName = defaultConfigurationName) => {
    const getOidc = vanillaOidc_js_1.VanillaOidc.get;
    const [state, setIDToken] = (0, react_1.useState)(initIdToken(configurationName));
    (0, react_1.useEffect)(() => {
        let isMounted = true;
        const oidc = getOidc(configurationName);
        if (oidc.tokens) {
            const tokens = oidc.tokens;
            setIDToken({ idToken: tokens.idToken, idTokenPayload: tokens.idTokenPayload });
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const newSubscriptionId = oidc.subscribeEvents((name, data) => {
            if (name === vanillaOidc_js_1.VanillaOidc.eventNames.token_renewed ||
                name === vanillaOidc_js_1.VanillaOidc.eventNames.token_aquired ||
                name === vanillaOidc_js_1.VanillaOidc.eventNames.logout_from_another_tab ||
                name === vanillaOidc_js_1.VanillaOidc.eventNames.logout_from_same_tab ||
                name === vanillaOidc_js_1.VanillaOidc.eventNames.refreshTokensAsync_error ||
                name === vanillaOidc_js_1.VanillaOidc.eventNames.syncTokensAsync_error) {
                if (isMounted) {
                    const tokens = oidc.tokens;
                    setIDToken(tokens != null ? { idToken: tokens.idToken, idTokenPayload: tokens.idTokenPayload } : idTokenInitialState);
                }
            }
        });
        return () => {
            isMounted = false;
            oidc.removeEventSubscription(newSubscriptionId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configurationName]);
    return state;
};
exports.useOidcIdToken = useOidcIdToken;
//# sourceMappingURL=ReactOidc.js.map